import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as offerings from '../../offerings'

export const RESOURCE = {
  payload: {
    description:
      'A specific product or service that is offered by an institution',
    dimension: offerings.RESOURCE.payload,
    level: 0,
    name: 'Offering',
    partialId: PartialId.Standard.create('offering'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
